<template>
  <div class="multiple">
    <!-- <grid ref="gridMulti" 
      :style="{height: `${gridHeight}px`}" 
      v-if="state.active_db && this.state.active_tab.resultMulti.length == 1" 
      :tab="state.active_tab.resultMulti" 
      :bHeight="gridHeight"
      :key="tabName + 'grid'"
      :tabName="tabName"

    /> -->
    <div v-if="state.active_db && this.state.active_tab.resultMulti.length > 1" :style="{height: `100%`, width: `100%`}" class="response-wrapper">
      <div class="nav-wrapper">
        <div class="navSelect" :class="{'dark-theme': dark}">
          <Btnarrow :class="{'darkBtn': dark}" :nav="'<'" @click.native="goBack"/>
          <Btnarrow :class="{'darkBtn': dark}" :nav="'>'" @click.native="goForward" class="btnForw"/>
          <v-sel
            :filterable="false"
            @open="onOpen"
            @close="onClose"
            @search="query => search = query"
            class="style-chooser"
            style="width:534px;margin-left:0;"
            :options="paginated"
            label="option"
            v-model="selectResponse"
            @input="vueSelectInput"
            :clearable="false"
          >
            <template #list-footer>
              <li ref="load" class="loader" v-show="hasNextPage">
                Loading more options...
              </li>
            </template>
          </v-sel>
        </div>
        <button v-on:click="$emit('clearResult')" class="clear">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g id="close">
              <path id="x" d="M18.717 6.697l-1.414-1.414-5.303 5.303-5.303-5.303-1.414 1.414 5.303 5.303-5.303 5.303 1.414 1.414 5.303-5.303 5.303 5.303 1.414-1.414-5.303-5.303z"/>
            </g>
          </svg>
        </button>
      </div>
      <ul :class="{addScroll: checkedAll, removeScroll: !checkedAll}" class="sel-list" v-if="selectResponse.option !== null && selectResponse.option === 'All'">
        <li v-for="(el,index) in getDataList" :key="el.option" :class="{'container-result': el.type === 1 || el.type === 0}">
          <div class="wrapper-result" v-if="el.type || el.type === 0">
            {{el.option}}<span :class="{'err-result': el.err > 0}">{{showRes(el)}}</span>
            <div v-if="el.type === 1 || el.type ===0" class="arrow" :class="{activeEl : responseList[index].selectClick}" @click="selectHandler(el,index)"></div>
          </div>
          <!-- <grid style="height:250px" v-if="el.type === 1 && el.selectClick" :result="el.result" :tab="state.active_tab.resultMulti" :key="tabName +'multi'+ responseList[index].result.quey" :bHeight="250"/> -->
          <!-- <grid style="height:250px" v-if="el.type === 1 && el.selectClick" :result="el.result" :tab="state.active_tab.resultMulti" :key="tabName +'multi'+ index" :bHeight="250" :width="gWidth" /> -->
          <!-- <grid style="height:250px" v-if="el.type === 1 && el.selectClick === true"  -->
          <grid style="height:250px" v-if="el.selectClick" 
            :result="el.result" 
            :tab="state.active_tab" 
            :key="tabName +'multi'+ index" 
            :bHeight="250" 
            :width="gridWidth-19-16" 
            :state="state"
            :selectIndx = "el.result.query-1"  
            :query = "el.result.query-1"
            :dark="dark"
          />
          <div style="color: red" v-if="el.type === 0 && el.selectClick">{{el.result.data.msg}}</div>
        </li>
      </ul>
      <div v-if="selectResponse.type && selectResponse.type !==1">
        <span>{{selectResponse.option}}{{selectResponse.result}}</span>
      </div>
      <!-- <grid ref="gridMulti" :style="{height: `${gridHeight}px`}" v-if="selectResponse && selectResponse.type == 1" :tab="state.active_tab.resultMulti" :bHeight="gridHeightM" :key="grid_key"/> -->
      <grid ref="gridMulti" 
        :style="{height: `${gridHeight}px`}" 
        v-if="selectResponse && selectResponse.type == 1" 
        :tab="state.active_tab" 
        :bHeight="gridHeightM" 
        :width="bWidth-16"
        :state="state"
        :selectIndx = "this.selectResponse.query"  
        :query = "this.selectResponse.query"
        :key="grid_key"
        :dark="dark"
        />
        <div style="color: red" v-if="selectResponse && selectResponse.type == 0">{{selectResponse.result.data.msg}}</div>
      </div>
  </div>
</template>

<script>
  import grid from './baseComponents/grid.vue'
  import Btnarrow from './baseComponents/button-nav.vue'

  export default {
    mounted() {
      this.getData()
      this.observer = new IntersectionObserver(this.infiniteScroll)
      if (this.selectResponse.result && this.selectResponse.result.query) {
        window.hostname.query = this.selectResponse.result.query
        let indx = this.selectResponse.result.query
        window.hostname.fields = this.state.active_tab.resultMulti[indx].fields
      }
    },
    created() {
      // this.responseList = this.getDataList
    },
    props: {
      state: {
        type: Object,
        required: true
      },
      bHeight: {
        required: true
      },
      tabName: {
        type: String,
        required: true
      },
      bWidth: {
        type: Number,
        required: true
      },
      dark: {
        type: Boolean
      }, 
    },
    components: {Btnarrow, grid},
    data: ()=> ({
      selectResponse: {option: null},
      flex: null,
      response: null,
      responseList: [],
      checkedAll: false,
      observer: null,
      limit: 10,
      search: '',
      grid_key: 0,
      selectIndx: 0,
      selectClick: false
    }),
    computed: {
      gridHeight: function() {
        return this.bHeight - 20
      },
      gridWidth: function() {
        // console.log('gW',this.gWidth);
        return this.bWidth
      },
      gridHeightM: function() {
        return this.bHeight - 65
      },
      responseResult: function(el){
        return el
      },
      filtered () {
        // console.log('filtered',this.responseList);
        let opt = this.responseList.filter(option => option.option.includes(this.search));
        return opt
      },
      paginated () {
        return this.filtered.slice(0, this.limit);
      },
      hasNextPage () {
        return this.paginated.length < this.filtered.length;
      },
      getDataList() {
        let arr = []  
        // debugger 
        arr.push({option:'All'})
        this.state.active_tab.resultMulti.forEach((el,ind) => {
          if (el.type === 0 && !el.err) {
            return arr.push('Result ' + ++ind + ': NONE ')
          }
          if (el.type === 0 && el.err) {
            return arr.push(
              {
                type: el.type,
                option: 'Result ' + ++ind + ': Error ',
                result: {
                  data: el,
                  idconnect: this.state.active_tab.idconnect,
                  query: ind
                },
                selectClick: false
              }
            )
          }
          if (el.type === 1) {
            arr.push(
              {
                type: el.type,
                option: 'Result ' + ++ind + ': SELECT ',
                result: {
                  data: el,
                  idconnect: this.state.active_tab.idconnect,
                  query: ind
                },
                selectClick: false
              }
            )
            return
          }
          if (el.type === 2) {
            arr.push(
              {
                type: el.type,
                option: 'Result ' + ++ind + ': INSERT ',
                result: 'Rowsaffected: '+ el.rowsaffected
              }
            )
            return
          }
          if (el.type === 3) {
            arr.push(
              {
                type: el.type,
                option: 'Result ' + ++ind + ': UPDATE ',
                result: 'Rowsaffected: '+ el.rowsaffected
              }
            )
            return
          }
          if (el.type === 4) {
            arr.push(
              {
                type: el.type,
                option: 'Result ' + ++ind + ': DELETE ',
                result: 'Rowsaffected: '+ el.rowsaffected
              }
            )
            return

          }
          if (el.type === 5) {
            arr.push(
              {
                type: el.type,
                option: 'Result ' + ++ind + ': TRANSACTION ',
                result: 'Rowsaffected: '+ el.rowsaffected
              }
            )
            return
          }
          if (el.type === 6 && el.err === 0) {
            arr.push(
              {
                type: el.type,
                option: 'Result ' + ++ind + ': ANOTHER ',
                result: 'Rowsaffected: '+ el.rowsaffected
              }
            )
            return
          }
          if (el.type === 6 && el.err > 0) {
            arr.push(
              {
                err: el.err,
                type: el.type,
                option: 'Result ' + ++ind + ': Error ',
                result:  el.msg
              }
            )
          }
        })
        // this.responseList = arr;
        console.log('getDataList',arr);
        return arr
      },      
      // grWidth: function() {
      //   return this.gWidth
      // },
    },
    methods: {
      // clearResult() {
      //   // console.log('click',this.tab.result);
      //   this.state.active_tab.resultMulti = []
      // },
      async onOpen () {
        if (this.hasNextPage) {
          await this.$nextTick();
          this.observer.observe(this.$refs.load)
        }
      },
      onClose () {
        // console.log('onClose', this.observer);
        this.observer.disconnect();
      },
      async infiniteScroll ([{isIntersecting, target}]) {
        if (isIntersecting) {
          const ul = target.offsetParent;
          const scrollTop = target.offsetParent.scrollTop;
          this.limit += 10;
          await this.$nextTick();
          ul.scrollTop = scrollTop;
        }
      },
      getData() {
        // this.responseList.push('All')   
        this.responseList.push({option:'All'})   
        this.state.active_tab.resultMulti.forEach((el,ind) => {
          if (el.type === 0 && !el.err) {
            return this.responseList.push('Result ' + ++ind + ': NONE ')
          }
          if (el.type === 0 && el.err) {
            return this.responseList.push(
              {
                type: el.type,
                option: 'Result ' + ++ind + ': Error ',
                result: {
                  data: el,
                  idconnect: this.state.active_tab.idconnect,
                },
                query: ind-1,
                selectClick: false
              }
            )
          }
          if (el.type === 1) {
            this.responseList.push(
              {
                type: el.type,
                option: 'Result ' + ++ind + ': SELECT ',
                result: {
                  data: el,
                  idconnect: this.state.active_tab.idconnect,
                },
                query: ind-1,
                selectClick: false
              }
            )
            return
          }
          if (el.type === 2) {
            this.responseList.push(
              {
                type: el.type,
                option: 'Result ' + ++ind + ': INSERT ',
                result: 'Rowsaffected: '+ el.rowsaffected,
                query: ind-1
              }
            )
            return
          }
          if (el.type === 3) {
            this.responseList.push(
              {
                type: el.type,
                option: 'Result ' + ++ind + ': UPDATE ',
                result: 'Rowsaffected: '+ el.rowsaffected,
                query: ind-1
              }
            )
            return
          }
          if (el.type === 4) {
            this.responseList.push(
              {
                type: el.type,
                option: 'Result ' + ++ind + ': DELETE ',
                result: 'Rowsaffected: '+ el.rowsaffected,
                query: ind-1
              }
            )
            return

          }
          if (el.type === 5) {
            this.responseList.push(
              {
                type: el.type,
                option: 'Result ' + ++ind + ': TRANSACTION ',
                result: 'Rowsaffected: '+ el.rowsaffected,
                query: ind-1
              }
            )
            return
          }
          if (el.type === 6 && el.err === 0) {
            this.responseList.push(
              {
                type: el.type,
                option: 'Result ' + ++ind + ': ANOTHER ',
                result: 'Rowsaffected: '+ el.rowsaffected,
                query: ind-1
              }
            )
            return
          }
          if (el.type === 6 && el.err > 0) {
            this.responseList.push(
              {
                err: el.err,
                type: el.type,
                option: 'Result ' + ++ind + ': Error ',
                result:  el.msg,
                query: ind-1
              }
            )
          }   
        })
        this.selectResponse = this.responseList[0]
        // console.log('getData',this.responseList);
        window.hostname.loading = false;
      },
      selectHandler(el,index) {
        console.log('selectHandler el', el, index);
        // console.log('selectHandler', this.responseList[index]);
        this.responseList[index].selectClick = !this.responseList[index].selectClick
        el.selectClick = !el.selectClick
        // console.log('selectHandler2', this.responseList[index]);
        // window.hostname.query = el.result.query
        // this.selectIndx = el.result.query
        // console.log('selectHandlerType', el.selectClick);
        // if (el.selectClick) {
        //   el.selectClick = false
        //   console.log('selectHandlerIf', el.selectClick);
        //   return 
        // }
        // el.selectClick = true
        // window.hostname.query = el.result.query
        this.selectIndx = el.result.query
        // console.log('selectHandlerEnd', el.selectClick);
      },
      showRes(el) {
        if (el.type === 1 || el.type == 0) {
          return
        }
        return el.result
      },
      vueSelectInput(val) {
        console.log('vueSelectVal',val);
        console.log('vueSelect',this.selectResponse);
        this.selectResponse = val
        console.log('vueSelect2',this.selectResponse);
        if (val && val.result) {
          console.log('vueSelectIf', val.query);
          window.hostname.query = val.query;
          console.log('vueSelectIf2', val.query);
        }
        this.grid_key++
      },
      selectedAll() {
        if (this.selectResponse.option === 'All') {
          this.checkedAll = true
          return
        } 
        this.checkedAll = false
      },
      goForward() {
        this.grid_key++      
        let indexSelected = this.responseList.findIndex(item => item.option === this.selectResponse.option)
        if (indexSelected === 0) {
          console.log("goForward",indexSelected+1);
          this.selectResponse = this.responseList[indexSelected+1]
          console.log("goForward",this.selectResponse);
          window.hostname.query = this.selectResponse.query;    
        }
        if (indexSelected+1 != this.responseList.length ) {
          this.selectResponse = this.responseList[indexSelected+1]
          window.hostname.query = this.selectResponse.query;          
        }
        this.selectedAll()
        console.log('goForward',window.hostname.query);
      },
      goBack(event) {
        this.grid_key--          
        let indexSelected = this.responseList.findIndex(item => item.option === this.selectResponse.option)
        if (indexSelected-1 === 0) {          
          this.selectResponse = this.responseList[0] 
          window.hostname.query = this.selectResponse.query;  
        }
        if (indexSelected-1 != 0 && indexSelected-1 > 0) {          
          this.selectResponse = this.responseList[indexSelected-1]
          window.hostname.query = this.selectResponse.query;          
        }        
        console.log("goBack",window.hostname.query);
        this.selectedAll()
      },
    }
  }
</script>

<style scoped>
  .darkBtn {
    background: rgba(127, 127, 127, 0.75);
  }
  .response-wrapper {
    display: flex;
    flex-direction: column;
    /* height: calc(100% - 28px); */
    padding-top: 7px;
  }

  .nav-wrapper {
    display: flex;
    justify-content: space-between;
  }
  .navSelect {
    display: flex;
    margin-left: 5px;
    align-items: center;
  }
  li {
    display: flex;
  }

  .container-result {
    display: flex;
    flex-direction: column;
  }

  .wrapper-result {
    display: flex;
  }

  .wrapper-result span {
    margin-left: 5px;
  }

  .err-result {
    color: red;
  }

  .arrow {
    cursor: pointer;
    margin-left: 5px;
    box-sizing: border-box;
    height: 10px;
    width: 10px;
    border-style: solid;
    border-color: rgb(159, 160, 160);
    border-width: 0px 1px 1px 0px;
    transform: rotate(45deg);
  }

  .activeEl {
    margin-top: 6px;
    transform: rotate(225deg);
    transition: border-width 150ms ease-in-out;
  }

  .arrow:hover {
    border-bottom-width: 4px;
    border-right-width: 4px;
  }

  .wj-flexgrid {
    height:calc(100% - 28px);
  }

  .sel-list {
    height: calc(100% - 28px);
    padding-left: 0;
  }

  .addScroll {
    overflow: auto;
  }

  .removeScroll {
    overflow: hidden;
  }

.dark-theme {
  --vs-dark-bg: #1e1e1e;
  --vs-dark-text: #f0f0f0;
  --vs-dark-border: #444;
  --vs-dark-hover: #333;
  --vs-dark-disabled: #555;

  --vs-dropdown-bg: var(--vs-dark-bg);
  --vs-dropdown-color: var(--vs-dark-text);
  --vs-dropdown-option-color: var(--vs-dark-text);
  --vs-dropdown-option--active-bg: var(--vs-dark-hover);
  
  --vs-selected-bg: var(--vs-dark-hover);
  --vs-selected-color: var(--vs-dark-text);
  
  --vs-search-input-bg: var(--vs-dark-bg);
  --vs-search-input-color: var(--vs-dark-text);
  --vs-search-input-placeholder-color: var(--vs-dark-disabled);
  
  --vs-controls-color: var(--vs-dark-text);
  --vs-clear-color: var(--vs-dark-text);
  --vs-open-indicator-color: var(--vs-dark-text);
  
  --vs-border-color: var(--vs-dark-border);
  --vs-border-width: 1px;
  --vs-border-radius: 4px;
  
  --vs-state-disabled-bg: var(--vs-dark-disabled);
  --vs-state-disabled-color: #777;
}
</style>
